import apiClient from "../../apiClient/apiClient";
import endPoints from "./endPoints";
import { UserClaimApiType } from "./types/apiTypes";

const userClaimApi: UserClaimApiType = {
  get: (value) => apiClient.get(endPoints.userClaim.get(value)),
  getLookups: (value) => apiClient.get(endPoints.userClaim.getLookups(value)),
  save: (payload) => apiClient.post(endPoints.userClaim.save(), payload),
};

export default userClaimApi;
